module.exports = __webpack_public_path__ + "static/media/vf_wblouse_core.185a7269.svg";